import { Pipe } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { PrefixedTranslatePipe } from './prefixed-translate.pipe'

@Pipe({
  name: 'schoolShift',
  pure: false
})
export class SchoolShiftPipe extends PrefixedTranslatePipe {

  constructor (translatePipe: TranslatePipe) {
    super(translatePipe, 'SCHOOL_SHIFTS.')
  }
}
